import styles from 'sections/welcomeAnim/welcomAnimHero/welcomeAnimHero.module.css';
import generalStyles from 'index.module.css';

import { Element } from 'react-scroll';
import { useTranslation } from 'react-i18next';
import { AnimatedPart } from 'components/animatedPart/AnimatedPart';

export const WelcomeAnimHero = () => {
    const { t } = useTranslation();

    return (
        <section
            id="section-welcome-anim-hero"
            className={`${generalStyles.heightAuto} ${styles.welcomeAnimSection}`}
        >
            <Element name="welcomeAnimHero">
                <div className={styles.welcomeAnim}>
                    <div className={styles.text}>
                        <AnimatedPart>
                            <h1
                                className={`${styles.heading} animated-items`}
                                style={{ whiteSpace: 'pre' }}
                            >
                                {t('welcomeAnim.welcomeAnimTitle')}
                            </h1>
                        </AnimatedPart>
                    </div>
                </div>

                <div className={generalStyles.container}>
                    <div className={styles.welcomeAnim__info}>
                        <h2 className={styles.info__title}>
                            {t('welcomeAnim.welcomeAnimTitle')}
                        </h2>
                        <p className={styles.info__text}>
                            {t('welcomeAnim.aDynamicAndElegantWayToGreet')}
                        </p>
                    </div>
                </div>
            </Element>
        </section>
    );
};
